import { getQueryParams, isNullOrUndef, isString } from "@civicscience/chops";

type buildPaginationFromQueryParamsProps = {
  locationSearch?: string;
  defaultSortTerm?: string;
  defaultSearchTerm?: string;
  defaultPage?: number;
  defaultSize?: number;
};

type buildPaginationFromQueryParamsReturn = {
  page: string | number;
  size: string | number;
  isSearch: boolean;
  searchTerm: string;
  sortTerm: string;
  defaultSize: number;
  defaultSearchTerm: string;
  defaultSortTerm: string;
  locationSearch: string;
  queryParams: URLSearchParams;
};

const buildPaginationFromQueryParams = ({
  locationSearch = "",
  defaultSortTerm = "",
  defaultSearchTerm = "",
  defaultPage = 1,
  defaultSize = 10,
}: buildPaginationFromQueryParamsProps): buildPaginationFromQueryParamsReturn => {
  const queryParams = getQueryParams(locationSearch);
  const pageQP = queryParams.get("page");
  const sizeQP = queryParams.get("size");
  const page = (isString(pageQP) ? parseFloat(pageQP) : pageQP) || defaultPage;
  const size = (isString(sizeQP) ? parseFloat(sizeQP) : sizeQP) || defaultSize;

  const searchTerm = queryParams.get("search") || defaultSearchTerm;
  const isSearch = !isNullOrUndef(queryParams.get("search"));
  const sortTerm = queryParams.get("sort") || defaultSortTerm;

  return {
    page,
    size,
    sortTerm,
    searchTerm,
    isSearch,
    defaultSize,
    defaultSearchTerm,
    defaultSortTerm,
    locationSearch,
    queryParams,
  };
};

export default buildPaginationFromQueryParams;
